const context = require.context('./app-types/', true, /\.html$/);

export const templateUrl = slug => {
    const key = `./${slug}/index.html`;
    if (context.keys().includes(key)) {
        return context(key);
    }
};

export const instructionsExist = slug => {
    return !!templateUrl(slug);
};



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/paths.js